
export default function AppObjectFieldObjectType({ field, value }) {
  console.log(`AppObjectFieldObjectType rendered: ${field.name}`)

  return (
    <div>
      {value}
    </div>
  )
}
